// src/hooks/useUpdload.js
import { useState } from 'react';
import { API_BASE, authHeader } from '../utils/api';

export default function useUpload() {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  async function uploadFile(file, token) {
    setError(null);
    if (!file) {
      setError('Please choose a CSV file.');
      throw new Error('No file selected');
    }

    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);

      const res = await fetch(`${API_BASE}/upload/`, {
        method: 'POST',
        headers: {
          ...authHeader(token),
          // NOTE: do NOT set Content-Type; the browser sets proper multipart boundary
        },
        body: fd,
      });

      const ct = res.headers.get('content-type') || '';
      const body = ct.includes('json') ? await res.json() : await res.text();

      if (!res.ok) {
        const msg =
          (body && (body.detail || body.message)) ||
          `Upload failed (${res.status})`;
        throw new Error(msg);
      }

      // Body can contain e.g. { data, column_types, company, unit_scale } depending on backend
      return body;
    } catch (err) {
      setError(err.message || 'Upload failed.');
      throw err;
    } finally {
      setUploading(false);
    }
  }

  return { uploading, error, setError, uploadFile };
}

